module.exports = __webpack_public_path__ + "img/0Q3A7268_FoamcoreMatted.11e97b89.jpg";